import './DocumentRow.css';
import { Box, ListItem, ListItemText, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AppFile from '../../../../../../models/AppFile';
import ButtonFileUploader from '../../../../../../components/Buttons/ButtonFileUploader';
import { FileType } from '../../../../../../models/FileType';
import HelpIcon from '@mui/icons-material/Help';
interface DocumentRowProps {
  fileSize: string;
  defaultFile: AppFile | null;
  fileName: string | null | undefined,
  documentType: FileType;
  setFile: (file: AppFile | null) => void,
  label: string,
  validation?: React.ReactNode
  buttonLabel: string,
  allowedExtensions: string[],
  infoText?: string
  infoTextLine2?: string,
  style?: React.CSSProperties
  styleContent?: React.CSSProperties
  buttonStyle?: React.CSSProperties;
  tooltipLabel?: string
}

const DocumentRow: React.FC<DocumentRowProps> = ({ fileSize, defaultFile, fileName, documentType, setFile, label, buttonLabel, validation, allowedExtensions, infoText, infoTextLine2, style, styleContent, buttonStyle, tooltipLabel }) => {
  const { t } = useTranslation()
  return (
    <Box className="step-container-5__box-row" style={fileName ? { backgroundColor: '#ddffdd', ...style } : { ...style }}>
      <ListItem >
        <div className="step-container-5__box-row__content" style={{ ...styleContent }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: '100%' }}>
            <div className='REQXXI-DocumentRow-ContainerLabel'>
              <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                <ListItemText>{label} </ListItemText>
                {
                  tooltipLabel &&
                  <Tooltip title={t(`${tooltipLabel}`)} >
                    <HelpIcon style={{fill: '#666', marginRight: '10px'}}/>
                  </Tooltip>
                }
              </Box>
              <div className='REQXX-DocumentRow-FileInfoMobile'>
                {fileSize &&
                  <Typography color="#949494" style={{ fontSize: '10px' }}>{`(${t('maximum')} ${fileSize.toUpperCase()})`}</Typography>
                }
                <Typography color="#949494" style={{ fontSize: '10px' }}>{`(${t('allowedType')} ${allowedExtensions})`}</Typography>
              </div>
            </div>
            <div className='REQXXI-DocumentRow-InfoLabel'>
              <Typography color="#949494" style={{ fontSize: '10px' }}>
                {infoText}
              </Typography>
              <Typography color="#949494" style={{ fontSize: '10px' }}>
                {infoTextLine2}
              </Typography>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <div className='REQXX-DocumentRow-UploadContainer'>
              <ButtonFileUploader
                defaultFile={defaultFile}
                documentAllowedSize={fileSize}
                inputFileDocumentName={label}
                label={buttonLabel}
                documentType={documentType}
                validation={validation}
                onFileUploded={(fileApp) => setFile(fileApp)}
                buttonStyle={buttonStyle} />
            </div>
          </div>
        </div>
      </ListItem>
    </Box>
  );
};

export default DocumentRow;
